import {
  DataDisplay,
  GeneralErrorUI,
  LoadingProgress,
  ReadonlyStack,
} from '@issuemanager/apps/client/components';
import {
  WithTheme,
  useAtlasSemanticThemeTokens,
} from '@issuemanager/apps/client/theme';
import { useStatistics } from '@issuemanager/client/features/issues';
import { Box, BoxProps, Grid, styled } from '@mui/material';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { mapDataToIndicators } from './utils';

const StyledBox = styled(Box)<WithTheme<BoxProps>>(({ theme }) => ({
  backgroundColor: theme.tokens.semantic.color.background.container.value,
}));

export function Statistics(): JSX.Element {
  const { t } = useTranslation('issue');
  const semantic = useAtlasSemanticThemeTokens();

  const statistics = useStatistics();

  const data = mapDataToIndicators(statistics.data ?? {}, t, semantic);

  if (statistics.isError) {
    return <GeneralErrorUI />;
  }

  return (
    <StyledBox p={3}>
      {statistics.isFetching ? (
        <LoadingProgress />
      ) : (
        <ReadonlyStack>
          <Box flex={1}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <DataDisplay
                  title={t('statistics.status.title')}
                  data={data.status}
                />
              </Grid>
            </Grid>
          </Box>
          <Box flex={1}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <DataDisplay
                  title={t('statistics.severity.title')}
                  data={data.severity}
                />
              </Grid>
            </Grid>
          </Box>
        </ReadonlyStack>
      )}
    </StyledBox>
  );
}
